module.exports = __webpack_public_path__ + "static/img/wapIcon_34.2dd9edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/wapIcon_34.jpg
// module id = Awbu
// module chunks = 3